import { numberMoney } from 'Data/format.js'
import { PAYMENTS_PAYMENT_TYPES } from 'Data/constants.js'

export function getAmount(item) {
  return numberMoney(Math.abs(item.amount))
}

export function getName(transaction) {
  return transaction.applied_payment.unapplied_payment
    ? 'Payment (Reversed)'
    : 'Payment'
}

export function getPaymentMethod(transaction) {
  let payment = transaction.applied_payment.payment
  switch (payment.payment_type) {
    case PAYMENTS_PAYMENT_TYPES.AutoPayment:
      return ``

    default:
      return ''
  }
}
